import React, { useEffect } from 'react';
import { getElementStyleMathValue } from '@gp/utils/common';
// @ts-ignore
import { storage } from '@gp/utils/utils';
import { DPS_REPORT_STORAGE_KEY } from '@gp/constants/storageKeys';
import { DPS_REPORT_MODULE_KEYS } from '../constants';

const getModuleNodeDistance = (moduleNode?: Element | null): number => {
  if (!moduleNode) return 0;
  const moduleNodeStyle = window.getComputedStyle(moduleNode, null);
  const boxSizing = moduleNodeStyle.getPropertyValue('box-sizing');
  const marginBottom = Number.parseFloat(moduleNodeStyle.getPropertyValue('margin-bottom'));
  const paddingTop = Number.parseFloat(moduleNodeStyle.getPropertyValue('padding-top'));
  const paddingBottom = Number.parseFloat(moduleNodeStyle.getPropertyValue('padding-bottom'));
  const height = Number.parseFloat(moduleNodeStyle.getPropertyValue('height'));
  const heightTmp = boxSizing === 'content-box' ? paddingTop + paddingBottom + height : height;
  return heightTmp + marginBottom;
};

const calcScrollDistance = (reportScrollableNode?: Element | null, moduleKey?: string): number => {
  if (!reportScrollableNode) return 0;
  const topbarNode = reportScrollableNode.querySelector('.dbg-dps-report__topbar');
  const topbarNodeDistance = getModuleNodeDistance(topbarNode);
  const filterNode = reportScrollableNode.querySelector('.dbg-dps-report__filter');
  const filterNodeDistance = getModuleNodeDistance(filterNode);
  const wallpaperNode = reportScrollableNode.querySelector('.dbg-dps-report-wallpaper');
  const wallpapaerPaddingTop = getElementStyleMathValue(wallpaperNode as Element, 'padding-top');
  const moduleNodes = wallpaperNode?.querySelector('.dbg-dps-report-wallpaper__content')?.children || [];
  const moduleKeys = Array.from(moduleNodes).map((moduleNode) =>
    moduleNode?.getAttribute('data-dps-report-module-key'),
  );
  if (!moduleKey || !moduleKeys.includes(moduleKey)) return 0;
  let distance = topbarNodeDistance + filterNodeDistance;

  for (let i = 0; i < moduleNodes?.length; i++) {
    const moduleNode = moduleNodes[i];
    if (moduleNode.getAttribute('data-dps-report-module-key') === moduleKey) break;
    distance = distance + getModuleNodeDistance(moduleNode);
  }

  return distance + wallpapaerPaddingTop;
};

export default function useAutoScroll(props?: {
  reportScrollableNode?: React.RefObject<HTMLDivElement>;
  deps?: React.DependencyList;
}) {
  const { reportScrollableNode, deps } = props || {};

  useEffect(() => {
    const moduleKey = storage.getSessionStorageItem(DPS_REPORT_STORAGE_KEY.DPS_REPORT_SCROLL_TOP_MODULE, true);
    if (!moduleKey || !DPS_REPORT_MODULE_KEYS.includes(moduleKey)) return;
    if (!reportScrollableNode?.current) return;

    reportScrollableNode.current?.scrollTo({
      top: calcScrollDistance(reportScrollableNode.current, moduleKey),
      behavior: 'smooth',
    });
  }, [deps]);
}
